import { CommonResponse, get } from '../requestNew';

export interface SeasonOption {
  gameSession: string;
  gameSessionName: string;
}

export interface WorkbenchOverview {
  updatedAt: string;
  queryDate: string;
  days: number;
  session: string;
  seasons: SeasonOption[];
  currentGame: {
    gameSession: string;
    gameSessionName: string;
    gameStatus: string;
    gameStatusText: string;
    gameStartTime: string;
    gameEndTime: string;
    participantCount: number;
    groupCount: number;
  };
  today: {
    reportedUsers: number;
    previousReportedUsers: number;
    reportedUserChange: number;
    expectedUsers: number;
    unreportedUsers: number;
    completionRate: number;
    pendingOrders: number;
    overdueOrders: number;
    abnormalOrders: number;
    activeUsers: number;
    activeUserChangeRate: number | null;
  };
  todo: {
    pendingOrders: number;
    abnormalOrders: number;
    penaltyPending: number;
    reportCountToday: number;
    riskCommentPending: number;
    rankCommentPending: number;
  };
  groups: Array<{
    groupType: number;
    name: string;
    expected: number;
    reported: number;
    completionRate: number;
    pending: number;
    abnormal: number;
  }>;
  queue: Array<{
    id: number;
    openId: string;
    gameName: string;
    groupType: number;
    groupName: string;
    issueSummary: string;
    todayEarningRate: number;
    waitingMinutes: number;
    priority: string;
    createTime: string;
  }>;
  dataWarnings: string[];
}

export async function fetchWorkbenchOverview(params: { days: number; session?: string }) {
  const response = await get<CommonResponse<WorkbenchOverview>>('/workbench/overview', params);
  if (response.code !== 200) {
    throw new Error(response.message || '数据加载失败');
  }
  return response.data;
}

export function formatNumber(value?: number | null) {
  return value === null || value === undefined ? '—' : value.toLocaleString('zh-CN');
}

export function formatPercent(value?: number | null, digits = 1) {
  return value === null || value === undefined ? '—' : `${value.toFixed(digits)}%`;
}

export function formatDateTime(value?: string | null) {
  return value ? value.replace('T', ' ').slice(0, 16) : '—';
}

export function formatWaiting(minutes?: number | null) {
  if (minutes === null || minutes === undefined) return '—';
  if (minutes < 60) return `${minutes} 分钟`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} 小时 ${rest} 分` : `${hours} 小时`;
}
